import hasFeature from 'modules/core/lib/hasFeature'

export const hasOnboardingEnabled = () => {
  return hasFeature('employee_onboarding')
}
